import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ProductShotBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Product Shot 1",
  version: 1,
  nameI18n:
    "settings.emails.visual_builder.block_type.product_shot.product_shot_1",
  category: [ProductShotBlock],
  props: {
    headerContent: {
      name: "Header Content",
      nameI18n:
        "settings.emails.visual_builder.prop_type.product_shot_1.header_content",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      type: "children",
    },
    footerContent: {
      name: "Footer Content",
      nameI18n:
        "settings.emails.visual_builder.prop_type.product_shot_1.footer_content",
      prop: "children",
      accepts: ["Basic", "Media", "Text", "Actions"],
      type: "children",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          defaultValue: defaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
      },
    },
  },
};
